import { render, staticRenderFns } from "./Tokuteiginoshien.vue?vue&type=template&id=1b1c2134&scoped=true"
import script from "./Tokuteiginoshien.vue?vue&type=script&lang=js"
export * from "./Tokuteiginoshien.vue?vue&type=script&lang=js"
import style0 from "./Tokuteiginoshien.vue?vue&type=style&index=0&id=1b1c2134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c2134",
  null
  
)

export default component.exports